<template>
  <div class="main">
    <van-nav-bar title="交存详情" left-arrow @click-left="onClickLeft" />
    <div class="repeat-box">

      <img src="../../assets/img/img_toupiao_nodata.png" alt="" class="repeat-img">
      <p class="repeat-desc">{{ decodeURI(msg) }}</p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      msg: ''
    };
  },
  mounted() {
    this.msg = this.$route.query.msg || '--'
  },
  methods: {
    onClickLeft() {
      window.history.go(-1)
    },
  }
}

</script>

<style lang="less" scoped>
.main {
  background-color: #f4f7f9;
  height: 100vh;
}

.repeat-box {
  overflow: hidden;
  width: 100%;
  height: 100%;
  // padding: 60px 0;
  text-align: center;
  color: #999;

  img {
    display: inline-block;
    width: 240px;
  }
}
</style>
